import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';

const { GET } = api;

const IP_RESOURE_BASE_PATH = 'https://ipapi.co';

export interface IpResource {
  getCountry: ResourceFetch<{ country: string }>;
}

const IpResource: IpResource = {
  getCountry: GET(`${IP_RESOURE_BASE_PATH}/json`, { authenticated: false }),
};

export default IpResource;
